module.exports = __webpack_public_path__ + "media/application/images/guides-test-img-4df8c1781565d67d01fea3287707ad11.png";